import { Component } from "react"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Switch */
import Switch from "react-switch"

/* Components */
import { Input } from "../../components"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { get, setParameters } from "../../api/Table"

/* Helpers */
import { utils } from "../../helpers"

/* Constants */
import { env } from "../../constants"

/* Widgets */
import Layout from "./Layout"

/* Swal */
import Swal from "sweetalert2"

/* SOCKET.IO */
import { io } from "socket.io-client"

/* JWT */
import { decodeToken } from "react-jwt"



/* Widget Control */
class Control extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            visible: false,
            available: false,
            closed: false,
            open24Hours: false,
            workStartTime: "",
            workEndTime: "",
            waiting: false,
        }

        this.bridge = null
    }

    componentDidMount = () => {

        /* Load Data */
        this.load()

        /* Connect to Bridge */
        this.connect()
    }

    componentWillUnmount = () => {
        if (this.bridge) {
            this.bridge.disconnect()
        }
    }

    /* Load Table Data */
    load = (reload = false) => {

        /* Fields */
        const { uid } = this.props

        /* Check Params */
        if (!uid) {
            this.setState({ status: "error" })
            return
        }

        /* Refresh the page if necessary */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        get({ uid }).then((response) => {
            if (response.status) {

                const data = response.data

                this.setState({
                    status: "ok",
                    visible: utils.checkBoolean(data.visible),
                    available: utils.checkBoolean(data.available),
                    closed: utils.checkBoolean(data.closed),
                    open24Hours: utils.checkBoolean(data.open24Hours),
                    workStartTime: utils.checkValue(data.workStartTime, ""),
                    workEndTime: utils.checkValue(data.workEndTime, ""),
                })

            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission" })
            }
            else if (response.status === 498) {
                this.setState({ status: "key" })
            }
            else {
                this.setState({ status: "error" })
            }
        }).catch(() => {
            this.setState({ status: "network" })
        })
    }

    /* Connect to Bridge */
    connect = () => {

        /* Get Token */
        const token = localStorage.getItem("token")
        const decoded = decodeToken(token)

        this.bridge = io(env.bridgeURL, { auth: { token: `${decoded.token}`, type: "admin" } })

        /* On Connect */
        this.bridge.on("connect", () => {
            Swal.fire(utils.notification(t("control.bridgeConnected"), "info"))
        })

        /* On Connect */
        this.bridge.on("connect_error", () => {
            Swal.fire(utils.notification(t("control.bridgeError"), "error"))
        })

    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { visible, available, closed, open24Hours, workStartTime, workEndTime } = this.state
        const { uid, socket } = this.props

        if (!socket || !socket.connect) {
            Swal.fire(utils.notification(t("control.noGameConnection"), "error"))
            return
        }

        /* Check Working Times */
        if (!open24Hours) {

            /* Check Working Start Time */
            if (workStartTime.length !== 5) {
                this._workStartTime.error(t("control.enterTime"))
                return
            }

            /* Check Working End Time */
            if (workEndTime.length !== 5) {
                this._workEndTime.error(t("control.enterTime"))
                return
            }
        }

        /* Check Booleand */
        const check = (value) => value ? 1 : 0

        /* Prepare Data */
        const predata = {
            uid,
            visible: check(visible),
            available: check(available),
            closed: check(closed),
            open24Hours: check(open24Hours),
            workStartTime,
            workEndTime,
        }

        /* Start Loading */
        this.setState({ waiting: true })

        /* Send to REST API */
        setParameters(predata).then((response) => {
            if (response.status === 200) {
                socket.emit("tableClosed", { value: closed })

                if (this.bridge) {
                    this.bridge.emit("updateData", uid)
                }

                Swal.fire(utils.notification(t("swal.savedSuccess"), "success", 3000))
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }

    /* Draw Button */
    _button = () => {

        /* Fields */
        const { waiting } = this.state

        /* Check Loading */
        if (waiting) {
            return <div className="table--settings-button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="table--settings-button">{t("common.save")}</div>
    }

    render = () => {

        /* Fields */
        const { status, visible, available, closed, open24Hours, workStartTime, workEndTime } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="table--modal-content table--settings">

                {/* Visible */}
                <div className="table---settings-row">
                    <div className="table---settings-row-texts">
                        <span>{t("control.tableVisibility")}</span>
                        <div className="table---settings-row-text">{t("control.makePublicHidden")}</div>
                    </div>
                    <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ visible: value })} checked={visible} />
                </div>

                {/* Available */}
                <div className="table---settings-row">
                    <div className="table---settings-row-texts">
                        <span>{available ? t("control.tableFree") : t("control.tableBusy")}</span>
                        <div className="table---settings-row-text">{t("control.autoDetect")}</div>
                    </div>
                    <Switch disabled uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" checked={!available} onChange={() => { }} />
                </div>

                <div className="table---settings-space"></div>

                {/* Closed */}
                <div className="table---settings-row">
                    <div className="table---settings-row-texts">
                        <span>{t("control.tableAccess")}</span>
                        <div className="table---settings-row-text">{t("control.allowDeny")}</div>
                    </div>
                    <div className="table---settings-switch">
                        <Switch uncheckedIcon={false} checkedIcon={false} onColor="#f44336" onChange={(value) => this.setState({ closed: value })} checked={closed} />
                        {closed ? <div className="table---settings-switch-text red">{t("control.tableClosed")}</div> : <div className="table---settings-switch-text green">{t("control.tableOpen")}</div>}
                    </div>
                </div>

                {/* Open 24 Hours */}
                <div className="table---settings-row">
                    <div className="table---settings-row-texts">
                        <span>{t("control.allDay")}</span>
                        <div className="table---settings-row-text">{t("control.allDayWork")}</div>
                    </div>
                    <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ open24Hours: value })} checked={open24Hours} />
                </div>

                {/* Working Times */}
                <div className="table---settings-row-inputs">
                    <Input ref={(ref) => this._workStartTime = ref} label={t("control.workStart")} mask="99:99" placeholder="__:__" disabled={open24Hours} value={workStartTime} onChange={(event) => this.setState({ workStartTime: event.target.value })} />
                    <Input ref={(ref) => this._workEndTime = ref} label={t("control.workEnd")} mask="99:99" placeholder="__:__" disabled={open24Hours} value={workEndTime} onChange={(event) => this.setState({ workEndTime: event.target.value })} />
                </div>

                <div className="table--settings-bottom">
                    {this._button()}
                </div>

            </div>
        )
    }
}

export default Control